export default __webpack_public_path__ + "static/media/warning-icon-blue.dabf0e6d.svg";